import React, { ChangeEvent, FC, FocusEvent } from 'react';
import RedStar from './RedStar';


type InputGroupProps = {
    label: string;
    name: string;
    handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
    handleBlur?: (event: FocusEvent<HTMLInputElement>) => void;
    type?: 'text' | 'file' | 'number' | 'email';
    value?: string | number;
    isRequired?: boolean;
    disabled?: boolean;
    errorMsg?: string | undefined;
}

const InputGroup: FC<InputGroupProps> = ({
    label,
    name,
    handleChange,
    handleBlur,
    type = 'text',
    value = '',
    isRequired = false,
    disabled = false,
    errorMsg = '',
}) => {

    let classes = 'form-control';
    const inputId = `input-${name}-id`;
    const hasError = errorMsg ? true : false;

    if (hasError) {
        classes += ' is-invalid';
    }

    return (
        <>
            <label className="form-label" htmlFor={inputId}>
                <div>
                    {label}
                    {isRequired ? <RedStar /> : ''}
                </div>
            </label>
            
            {/* File Input */}
            {type === 'file' && (
                <input type={type} disabled={disabled} onBlur={handleBlur} className={classes} onChange={handleChange} name={name} id={inputId} />
            )}
            
            {/* Other Input Types */}
            {type !== 'file' && (
                <input type={type} disabled={disabled} onBlur={handleBlur} className={classes} onChange={handleChange} name={name} id={inputId} value={value} />
            )}
          
            {hasError ? <div id='asas' className="invalid-feedback"> {errorMsg} </div> : ''}
        </>
    )
}

export default InputGroup;